module.exports = __webpack_public_path__ + "static/media/localizacaoMobile.f045ef1f.jpg";